import { Group, Paper, Stack, Title } from "@mantine/core";

import { AmendmentCardDetails } from "./AmendmentCardDetails";

export const AmendmentCardGroup = ({
  currentVersion,
  previousVersion,
  title,
  cardTitle = "Amended",
}: {
  currentVersion?: string;
  previousVersion?: string;
  title: string;
  cardTitle?: string;
}) => {
  return (
    <Paper p="md" withBorder>
      <Stack mb="lg">
        <Title order={3}>{title}</Title>
      </Stack>
      <Group grow align="flex-start">
        <AmendmentCardDetails
          showRemoved
          title="Previous"
          currentVersion={currentVersion}
          previousVersion={previousVersion}
        />
        <AmendmentCardDetails
          title={cardTitle}
          currentVersion={currentVersion}
          previousVersion={previousVersion}
        />
      </Group>
    </Paper>
  );
};
